// @flow

import type { PropsSchema, BasicProps } from '../../type'

import * as React from 'react'
import css from './Float.scss'
import onClickEvents from '../hoc/onClickEvent'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  style: { [string]: string },
  children: React.ChildrenArray<React.Node>,
  onClick: () => void
};

@computeData()
@onClickEvents
export default class Float extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'style',
      group: 'absolutePosition'
    }
  ];

  render () {
    if (!this.props.visible) {
      return null
    }
    const { id, style, children, onClick } = this.props
    return (
      <div className={css.main} style={style} id={id} onClick={onClick}>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Float.js